module.exports = __webpack_public_path__ + "resources/private-group-bc4d777a8f3e430ae0e3f313d68b5cb3.svg";